module.exports = __webpack_public_path__ + "static/media/smallPeerFivesLogo.52a411a3.svg";